import { render } from "./g-toast-container.vue?vue&type=template&id=2134102b&ts=true"
import script from "./g-toast-container.vue?vue&type=script&lang=ts"
export * from "./g-toast-container.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__